<h5>Consult Notes</h5>
@if (!loading) {
  @if (patientAttachments.length > 0) {
    <div>
      <p>Consult notes associated with this patient and prescriber.</p>
      <div class="scrollable">
        <table class="table table-sm table-striped">
          <thead>
            <th>DOCUMENT NAME</th>
            <th class="text-center">SPECIALIST VISIT DATE</th>
          </thead>
          <tbody>
            @for (patientAttachment of patientAttachments; track patientAttachment) {
              <tr>
                <td>
                  <a class="phi" target="_blank" [routerLink]="'/ce-portal/consult-note-viewer/' + patientAttachment.id"> {{ patientAttachment.fileName }} </a>
                </td>
                <td class="text-center">
                  @for (verification of patientAttachment.specialistEncounterVerifications; track verification) {
                    <div>
                      {{ verification.encounterDate | date: 'MM/dd/yyyy' }}
                    </div>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  } @else {
    <p>There are no consult notes associated with this patient and prescriber yet.</p>
  }
} @else {
  <mat-spinner [diameter]="30" />
}
